import { Bid } from '../dtos/bid';
import {
	BID_DISPLAY_STATUS_CONSTANTS,
	BID_SOURCE_TYPE,
	BID_STATUS_STRING,
} from '../constants/index';

export const GET_BID_STATUS_FROM_STRING = (
	status: string,
	sourceType: string,
	bid: Bid = null
): string => {
	switch (status.toLowerCase()) {
		case BID_STATUS_STRING.INVITED.toLowerCase():
			return BID_DISPLAY_STATUS_CONSTANTS.INVITED;
		case BID_STATUS_STRING.ACCEPTED.toLowerCase():
			return BID_DISPLAY_STATUS_CONSTANTS.ACCEPTED;
		case BID_STATUS_STRING.DECLINED.toLowerCase():
			return BID_DISPLAY_STATUS_CONSTANTS.DECLINED;
		case BID_STATUS_STRING.COUNTERED.toLowerCase():
			return sourceType == BID_SOURCE_TYPE.CARRIER
				? BID_DISPLAY_STATUS_CONSTANTS.COUNTER_RECEIVED
				: BID_DISPLAY_STATUS_CONSTANTS.COUNTER_SENT;
		case BID_STATUS_STRING.DRAFT.toLowerCase():
			return BID_DISPLAY_STATUS_CONSTANTS.RATE_CON_SENT;
		case BID_STATUS_STRING.SIGNED.toLowerCase():
			if (bid?.isEligibleForBookNow) {
				return BID_DISPLAY_STATUS_CONSTANTS.ASSIGNED;
			}
			return BID_DISPLAY_STATUS_CONSTANTS.SIGNED;
		case BID_STATUS_STRING.VIEWED.toLowerCase():
			return BID_DISPLAY_STATUS_CONSTANTS.VIEWED;
		case BID_STATUS_STRING.CANCELLED.toLowerCase():
			return BID_DISPLAY_STATUS_CONSTANTS.CANCELLED;
		case BID_STATUS_STRING.NEW.toLowerCase():
			return BID_DISPLAY_STATUS_CONSTANTS.NEW;
		case BID_STATUS_STRING.SELECTED.toLowerCase():
			return BID_DISPLAY_STATUS_CONSTANTS.SELECTED;
		case BID_STATUS_STRING.RESPONSE_RECEIVED.toLowerCase():
			return BID_DISPLAY_STATUS_CONSTANTS.RESPONSE_RECEIVED;
		case BID_STATUS_STRING.SCHEDULED.toLowerCase():
			return BID_DISPLAY_STATUS_CONSTANTS.SCHEDULED;
		case BID_STATUS_STRING.DAILY_LIMIT_REACHED.toLowerCase():
			return BID_DISPLAY_STATUS_CONSTANTS.DAILY_LIMIT_REACHED;
		default:
			return status;
	}
};
